<template>
  <div v-if="!isBlacklistLoading">
    <div class="import-button-wrapper">
      <button @click="openImportModal" class="button is-info">
        <span class="mdi mdi-upload"></span>
        CSVインポート
      </button>
    </div>
    
    <div class="setting-auto-flow-table-wrapper">
      <table class="disp-scroll">
        <thead>
          <tr>
            <th style="width: 15%">名前</th>
            <th style="width: 15%">電話番号</th>
            <th style="width: 30%">Email</th>
            <th style="width: 30%">備考</th>
            <th style="width: 10%">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <!-- 名前 -->
            <td>
              <input type="text" style="width:120px" v-model="applicantBlacklistNameInput"/>
            </td>
            <!-- 電話番号 -->
            <td>
              <input type="text" style="width:110px" v-model="applicantBlacklistTelInput"/>
            </td>
            <!-- Email -->
            <td>
              <input type="text" style="width:200px" v-model="applicantBlacklistEmailInput"/>
            </td>
            <!-- 備考 -->
            <td>
              <input type="text" style="width:200px" v-model="applicantBlacklistRemarksInput"/>
            </td>
            <!-- ボタン -->
            <td>
              <button
                @click="register"
                class="button is-small is-primary"
              >
                登録
              </button>
            </td>
          </tr>
          <tr v-for="(blacklist, i) in applicantBlacklistList" :key="i">
            <td>
              {{ blacklist.name }}
            </td>
            <td >
              {{ blacklist.tel }}
            </td>
            <td>
              {{ blacklist.email }}
            </td>
            <template>
              <td >
                {{ blacklist.remarks }}
              </td>
              <td>
                <button @click="deleteFlow(blacklist)" class="button is-small is-danger">削除</button>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- インポートモーダル -->
    <ImportBlacklistModal
      v-if="showImportModal"
      @close="closeImportModal"
      @imported="onImported"
    />
  </div>
  <div v-else><span class="mdi mdi-loading mdi-spin mdi-48px"></span></div>
</template>

<script>
import { mapState }      from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
import ImportBlacklistModal from '@/components/molecules/modals/ImportBlacklistModal'

export default {
  components: {
    ImportBlacklistModal
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('auth', ['user']),
  },
  data() {
    return {
      applicantBlacklistNameInput: "",
      applicantBlacklistEmailInput: "",
      applicantBlacklistTelInput: "",
      applicantBlacklistRemarksInput: "",
      errormessage: "",
      applicantBlacklistList: [],
      isBlacklistLoading: false,
      showImportModal: false
    }
  },
  created () {
    this.getApplicantBlacklist()
  },
  methods: {
    register() {
      if(!this.checkInput()) {
        alert(this.errormessage)
        return false
      }
      this.sendControlLog('採用フロー停止応募者追加', '採用フロー停止応募者設定にて、「登録」ボタンをクリックした。')
      this.createApplicantBlacklist(
        this.applicantBlacklistNameInput,
        this.applicantBlacklistEmailInput,
        this.applicantBlacklistTelInput,
        this.applicantBlacklistRemarksInput
      )
    },
    deleteFlow(blacklist) {
      this.sendControlLog('採用フロー停止応募者削除', '採用フロー停止応募者設定にて、「削除」ボタンをクリックした。\n削除確認にてキャンセルされた場合は、削除されなかった可能性があります。')
      this.deleteApplicantBlacklist(blacklist.id)
    },
    checkInput() {
      if((this.applicantBlacklistEmailInput == "" || this.applicantBlacklistEmailInput == null) && (this.applicantBlacklistTelInput == "" || this.applicantBlacklistTelInput == null)) {
        this.errormessage = 'Emailもしくは電話番号どちらかを入力してください'
        return false
      }
      // 電話番号については、-なしバージョンと-ありバージョンの2つでチェック
      const regex_tel1 = /^0\d{9,10}$/g
      const regex_tel2 = /^0\d{1,4}-\d{1,4}-\d{4}$/g
      if (this.applicantBlacklistTelInput.length > 0 && !regex_tel1.test(this.applicantBlacklistTelInput) && !regex_tel2.test(this.applicantBlacklistTelInput)) {
        this.errormessage = '正しい電話番号形式で入力してください'
        return false
      }
      const regex_email = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/g
      if (this.applicantBlacklistEmailInput.length > 0 && !regex_email.test(this.applicantBlacklistEmailInput)) {
        this.errormessage = '正しいEmail形式で入力してください'
        return false
      }
      return true
    },
    async createApplicantBlacklist (
      applicantBlacklistNameInput,
      applicantBlacklistEmailInput,
      applicantBlacklistTelInput,
      applicantBlacklistRemarksInput
    ) {
      let telTrim = applicantBlacklistTelInput.replaceAll('-','')
      const data = {
        company: this.user.companyPK,
        name: applicantBlacklistNameInput,
        email: applicantBlacklistEmailInput,
        tel: applicantBlacklistTelInput,
        tel_trim: telTrim,
        remarks: applicantBlacklistRemarksInput
      }
      try {
        const response = await this.$store.dispatch('directtalk/createApplicantBlacklist', data)
        if(response.data.status=="emailerror") {
          alert("Email重複エラー")
        } else if(response.data.status=="telerror") {
          alert("電話番号重複エラー")
        } else {
          this.applicantBlacklistList.unshift(JSON.parse(response.data))
          // 登録成功時にイベントを発火
          this.$emit('blacklist-added')
          alert("登録しました。")
        }
      } catch (e) {
        console.log(e)
        alert("エラーが発生しました。")
      }
    },
    async getApplicantBlacklist () {
      try {
        this.isBlacklistLoading=true
        const response = await this.$store.dispatch('directtalk/getApplicantBlacklist')
        let blacklistBuffer = JSON.parse(response.data)
        this.applicantBlacklistList = blacklistBuffer.reverse()
        this.isBlacklistLoading=false
      } catch (e) {
        console.log(e)
        alert("エラーが発生しました。")
        this.isBlacklistLoading=false
      }
    },
    async deleteApplicantBlacklist (id) {
      if (!confirm('この採用フロー停止応募者情報を削除してよろしいですか？')) {
        this.sendControlLog('採用フロー停止応募者情報の削除をキャンセル', '採用フロー停止応募者情報にて、削除ボタンをクリックした後の確認にて、削除をキャンセルした。')
        return
      }
      try {
        await this.$store.dispatch('directtalk/deleteApplicantBlacklist', id)
        this.applicantBlacklistList = this.applicantBlacklistList.filter(el => el.id !== id)
        // 削除成功時にイベントを発火
        this.$emit('blacklist-deleted')
        alert("削除しました。")
      } catch (e) {
        console.log(e)
        alert("エラーが発生しました。")
      }
    },
    openImportModal() {
      this.sendControlLog('CSVインポート画面表示', '採用フロー停止応募者設定にて、「CSVインポート」ボタンをクリックした。')
      this.showImportModal = true
    },
    closeImportModal() {
      this.showImportModal = false
    },
    async onImported(result) {
      // インポート成功後の処理
      this.showImportModal = false
      alert(`${result.success_count}件のデータをインポートしました。`)
      
      // リストを再取得
      await this.getApplicantBlacklist()
      
      // イベントを発火
      this.$emit('blacklist-added')
    }
  },
}
</script>

<style lang="scss" scoped>
.import-button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  
  .button {
    .mdi {
      margin-right: 4px;
    }
  }
}

.setting-auto-flow-table-wrapper {
  display: flex;
  justify-content: center;
  max-height: 700px; // スクロール可能な最大高さを設定
  overflow-y: auto; // 縦方向のスクロールを有効化
  width: 100%; // 幅を100%に設定
  table td:not([align]),
  table th:not([align]) {
    text-align: center;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    display: table; // blockからtableに変更
    //overflow: auto;
    table-layout: fixed;
  }
  // table::-webkit-scrollbar {
    //width: 5px;
    //height: 5px;
    //visibility: hidden;
  // }
  tr {
    width: 100%;
  }
  td,
  th {
    padding: 8px;
    margin: auto;
    font-size: smaller;
    border-style: solid;
    border-width: 1px;
    border-color: black;
  }
  td {
    text-align: left;
    vertical-align: middle;
    overflow: scroll;
    padding: 8px;
  }
  td > div::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    visibility: hidden;
  }
  th {
    color: #fff;
    background: #aa0066;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 10000;
  }
  table tr:nth-child(odd) {
    background: #ffeeff;
  }
  table tr:nth-child(even) {
    background: #fafafa;
  }
  .select-action {
    color: blue;
    cursor: pointer;
  }
  .select-target {
    width: auto;
    font-size: 13.33px;
    background-color: white;
    /deep/ .vs__selected-options {
      flex-wrap: nowrap;
    }
  }
  // スクロールバーのスタイルを追加
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/molecules/tables/SettingApplicantBlacklistTable.vue